module.exports = [
  {
    id: "0",
    name: "Verde",
    images: [
      {
        url: "https://images.unsplash.com/photo-1583195590626-4bc9554d3cb7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=676&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1587968829521-d11a66a0b64d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1543363136-9b070a911153?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
      },
    ],
    price: 2.99,
    description:
      "Our hardest-core green juice. Verde is all the green you need in the morning. For the early birds and the night owls, this sugar free concoction will get you ready for action.",
    tagline: "Our hardest-core green juice.",
  },
  {
    id: "1",
    name: "Amarilla",
    images: [
      {
        url: "https://images.unsplash.com/photo-1589606663923-283bbd309229?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1589820296156-2454bb8a6ad1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1543363363-6dbd3125fb6d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=700&q=80",
      },
    ],
    price: 3.99,
    description:
      "Pressed from Magdalena River mangos harvested from groves situated along the Cauca and Magdalena rivers in western Colombia.",
    tagline: "The freshest mangos from western Colombia.",
  },

  {
    id: "2",
    name: "Arancia",
    images: [
      {
        url: "https://images.unsplash.com/photo-1615421461869-69c341309bcd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1615634376658-c80abf877da2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1524638067-feba7e8ed70f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
    ],
    price: 2.55,
    description:
      "A smooth orange juice made using carefully selected sun-ripened oranges for a sweet, natural flavour. From concentrate. Five organic oranges per bottle. Best served chilled. Source of Vitamin C. 1 of your 5 a day.",
    tagline: "Perfect orange juice, yes, perfect",
  },
  {
    id: "3",
    name: "Zenzero",
    images: [
      {
        url: "https://images.unsplash.com/photo-1524062850143-d314efa60f57?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1492760864391-753aaae87234?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=668&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1543363136-2ae17fd2efc8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
      },
    ],
    price: 3.99,
    description:
      "Carrot, Apple, Ginger, and Mint. Put a bit of oomph into your morning.. Packed full of vitamins and minerals, these herbs and veggies are here to work every corner of your mind and body.",
    tagline: "Carrot, Apple, Ginger, and Mint- what more do you want?",
  },
  {
    id: "7",
    name: "Smeraldo",
    images: [
      {
        url: "https://images.unsplash.com/photo-1615385365748-9b46b7ae446e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1572565638061-ecff52429d86?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1551300739-125a008c9e85?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=664&q=80",
      },
    ],
    price: 4.99,
    description:
      "Our organic kiwi juice is made with 100% fresh fruit, no preservatives or conservatives, and will leave you feeling refreshed and energised.",
    tagline: "Our organic kiwi juice is made with 100% fresh fruit.",
  },
  {
    id: "5",
    name: "Gialla",
    images: [
      {
        url: "https://images.unsplash.com/photo-1601493700631-2b16ec4b4716?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1525385133512-2f3bdd039054?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=632&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1551561440-515f674d502e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=665&q=80",
      },
    ],
    price: 2.99,
    description:
      "Juicy organic mangos bring tropical flavour and a burst of creamy goodness. No nasty chemicals and preservatives, just wholesome nourishment.",
    tagline: "Juicy organic mangos bring tropical flavour.",
  },
  {
    id: "4",
    name: "Mirtillo",
    images: [
      {
        url: "https://images.unsplash.com/photo-1565585947268-dc5194ae29de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1572559451259-f53324c573aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1543363363-1fe620fe3d4b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
      },
    ],
    price: 3.55,
    description:
      "Handmade juices from freshly squeezed fruits. 100% Fruit; Nothing added and nothing taken away. No sugar added.",
    tagline: "Handmade juice from freshly fruits.",
  },
  {
    id: "6",
    name: "Viola",
    images: [
      {
        url: "https://images.unsplash.com/photo-1552526881-5517a57b6d4a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1578999766765-531ad2e09d97?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=564&q=80",
      },
      {
        url: "https://images.unsplash.com/photo-1525904220310-64ef12c1429b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=654&q=80",
      },
    ],
    price: 4.99,
    description:
      "Our organic smooth Viola is simply pressed, so more of its goodness reaches your glass. Our grapes come from carefully selected organic vineyards and are crushed immediately after harvest to capture all their intense sweetness.",
    tagline: "Our finest grapes, carefully selected organic vineyards.",
  }
];
